import { Routes, Route } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Suspense, lazy } from 'react'
import LoadingSpinner from './components/LoadingSpinner'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'

// Lazy load pages
const Home = lazy(() => import('./pages/Home'))
const Features = lazy(() => import('./pages/Features'))
const Pricing = lazy(() => import('./pages/Pricing'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const Help = lazy(() => import('./pages/Help'))
const Impressum = lazy(() => import('./pages/Impressum'))
const Datenschutz = lazy(() => import('./pages/Datenschutz'))
const SystemStatus = lazy(() => import('./pages/SystemStatus'))
const NotFound = lazy(() => import('./pages/NotFound'))

// SEO Landing Pages - Cities
const ZeiterfassungBerlin = lazy(() => import('./pages/ZeiterfassungBerlin'))
const ZeiterfassungMuenchen = lazy(() => import('./pages/ZeiterfassungMuenchen'))
const ZeiterfassungHamburg = lazy(() => import('./pages/ZeiterfassungHamburg'))
const ZeiterfassungKoeln = lazy(() => import('./pages/ZeiterfassungKoeln'))

// SEO Landing Pages - Industries
const ZeiterfassungSoftwareEntwicklung = lazy(() => import('./pages/ZeiterfassungSoftwareEntwicklung'))
const ZeiterfassungConsulting = lazy(() => import('./pages/ZeiterfassungConsulting'))
const ZeiterfassungMarketing = lazy(() => import('./pages/ZeiterfassungMarketing'))
const ZeiterfassungFreelancer = lazy(() => import('./pages/ZeiterfassungFreelancer'))

const queryClient = new QueryClient()

const antdTheme = {
  token: {
    colorPrimary: '#2563eb',
    colorLink: '#2563eb',
    colorSuccess: '#10b981',
    colorWarning: '#f59e0b',
    colorError: '#ef4444',
    colorInfo: '#3b82f6',
    borderRadius: 8,
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontSize: 14,
    colorText: '#1f2937',
    colorTextSecondary: '#6b7280',
    colorBgBase: '#ffffff',
    controlHeight: 40,
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 40,
      fontSize: 16,
      fontWeight: 500,
    },
    Card: {
      borderRadius: 12,
      paddingLG: 24,
    },
    Input: {
      borderRadius: 8,
      controlHeight: 40,
    },
  }
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={antdTheme}>
        <div className="min-h-screen bg-white">
          <ScrollToTop />
          <Navigation />
          <main>
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/features" element={<Features />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/help" element={<Help />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/status" element={<SystemStatus />} />
                
                {/* SEO Landing Pages - Cities */}
                <Route path="/zeiterfassung-berlin" element={<ZeiterfassungBerlin />} />
                <Route path="/zeiterfassung-muenchen" element={<ZeiterfassungMuenchen />} />
                <Route path="/zeiterfassung-hamburg" element={<ZeiterfassungHamburg />} />
                <Route path="/zeiterfassung-koeln" element={<ZeiterfassungKoeln />} />
                
                {/* SEO Landing Pages - Industries */}
                <Route path="/zeiterfassung-software-entwicklung" element={<ZeiterfassungSoftwareEntwicklung />} />
                <Route path="/zeiterfassung-consulting" element={<ZeiterfassungConsulting />} />
                <Route path="/zeiterfassung-marketing" element={<ZeiterfassungMarketing />} />
                <Route path="/zeiterfassung-freelancer" element={<ZeiterfassungFreelancer />} />
                
                {/* 404 Catch-all */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </ConfigProvider>
    </QueryClientProvider>
  )
}

export default App 